// web-frontend/src/components/common/SplashScreen.jsx
/**
 * 🚀 DSK 스플래시 화면 컴포넌트
 * 
 * 기능:
 * - 앱 시작 시 2초간 로고를 표시한 후 fade-out 효과와 함께 사라짐
 * - 라이트/다크 모드 지원
 * - DSK 브랜드 컬러 그라데이션 글로우 효과
 */

import React, { useState, useEffect } from 'react';
import defaultLogo from '../../assets/logo.png';
// 🎨 [2026-05-17] 멀티테넌트: tenant.assets.logo 가 명시되어 있으면 그 경로 사용
import { getEventName, getAssets } from '../../shared/config/tenant';
import './SplashScreen.css';

const SPLASH_DURATION = 2000; // 스플래시 표시 시간 (2초)
const FADE_DURATION = 500;   // 페이드 아웃 시간 (0.5초)

const SplashScreen = ({ onComplete }) => {
  const [isVisible, setIsVisible] = useState(true);
  const [isFading, setIsFading] = useState(false);

  useEffect(() => {
    const fadeTimer = setTimeout(() => {
      setIsFading(true);
    }, SPLASH_DURATION);

    const completeTimer = setTimeout(() => {
      setIsVisible(false);
      if (onComplete) onComplete();
    }, SPLASH_DURATION + FADE_DURATION);

    return () => {
      clearTimeout(fadeTimer);
      clearTimeout(completeTimer);
    };
  }, [onComplete]);

  if (!isVisible) return null;

  return (
    <div className={`splash-screen ${isFading ? 'splash-fade-out' : ''}`}>
      {/* ✅ Soft Sky 베이스 배경 */}
      <div className="splash-bg-base" />
      
      {/* ✅ 그라데이션 글로우 효과 */}
      <div className="glow-primary-top-right" />
      <div className="glow-secondary-bottom-left" />
      
      {/* 콘텐츠 */}
      <div className="splash-content">
        <img
          src={getAssets().logo || defaultLogo}
          alt={`${getEventName()} Logo`}
          className="splash-logo"
          onError={(e) => { e.currentTarget.src = defaultLogo; }}
        />
        {/* 🔥 [2026-06-29] 스플래시 태그라인 제거 (요청: 'The Global Hub Where Innovation Takes Off' 미표시) */}
      </div>
    </div>
  );
};

export default SplashScreen;
